import html2pdf from 'html3pdf';

//round up numbers to one decimal place
//ex: 1.01 => 1.1
export const roundUpToOneDecimal = num => {
  return Math.ceil(num * 10) / 10;
};

//round up to integer
//ex: 1.1 => 2
export const roundUpToInteger = num => {
  return Math.ceil(num);
};

//format fields values
//ex: 1000 => 1,000.00
export const formatNumber = (value, options) => {
  if (value === null || typeof value === 'undefined') return value;

  const _value = `${value}`;

  let addDecimals = false,
    decimalZero = '.00';

  const prefix = options && options.prefix ? options.prefix : '';
  const suffix = options && options.suffix ? options.suffix : '';
  const noZero = options && options.noZero ? options.noZero : false;

  if (noZero) {
    decimalZero = '';
  }

  const indexOfDot = _value.indexOf('.');

  if (indexOfDot === -1) {
    addDecimals = true;
  } else {
    const decimal = _value.split('.')[1];

    if (decimal) {
      const decimalNumber = Number(decimal);

      if (decimalNumber <= 0) {
        addDecimals = true;
      }
    } else {
      addDecimals = true;
    }
  }

  const formattedValue = `${prefix}${Number(_value).toLocaleString()}${
    addDecimals ? decimalZero : ''
  }${suffix}`;

  return formattedValue;
};

export const getTemperatureUsageForProPrimer = temp => {
  const tempNum = Number(temp);
  if (tempNum >= 32 && tempNum < 41) {
    return 3;
  }
  if (tempNum >= 41 && tempNum < 77) {
    return 2;
  }
  if (tempNum >= 77 && tempNum <= 95) {
    return 1;
  }
};

export const getTemperatureUsageForFlashingResin = temp => {
  const tempNum = Number(temp);
  if (tempNum >= 32 && tempNum < 41) {
    return 3;
  }
  if (tempNum >= 41 && tempNum < 59) {
    return 2;
  }
  if (tempNum >= 59 && tempNum <= 95) {
    return 1;
  }
};

export const getTemperatureUsageForProColorFinish = temp => {
  const tempNum = Number(temp);
  if (tempNum >= 32 && tempNum < 41) {
    return 3;
  }
  if (tempNum >= 41 && tempNum < 59) {
    return 2;
  }
  if (tempNum >= 59 && tempNum <= 95) {
    return 1;
  }
};

export const getTemperatureUsageForResinAggregate = temp => {
  const tempNum = Number(temp);
  if (tempNum >= 32 && tempNum < 59) {
    return 4;
  }
  if (tempNum >= 59 && tempNum <= 95) {
    return 2;
  }
};

export const downloadPDF = (elements, pdfOptions, downloadEndpoint) => {
  return new window.Promise((resolve, reject) => {
    try {
      let worker = html2pdf().set(pdfOptions).from(elements[0]),
        pageCount = 1;

      if (elements.length > 1) {
        worker = worker.toPdf(); // worker is now a jsPDF instance

        // add each element/page individually to the PDF render process
        elements.slice(1).forEach((element, index) => {
          worker = worker
            .get('pdf')
            .then(pdf => {
              pageCount++;
              pdf.addPage();

              if (pageCount === elements.length) {
                resolve();
              }
            })
            .from(element)
            .toContainer()
            .toCanvas()
            .toPdf();
        });
      }

      worker = worker.get('pdf').then(pdf => {
        const blob = pdf.output('blob');

        //POST the blob to the server

        const formData = new FormData();
        formData.append('file', blob);

        const blobType = new Blob([blob], {
          type: 'application/octet-stream'
        });

        const blobUrl = window.URL.createObjectURL(blobType);

        const filename = () => {
          if (pdfOptions.filename) {
            if (pdfOptions.filename.includes('.pdf')) {
              return pdfOptions.filename;
            }
            return `${pdfOptions.filename}.pdf`;
          }
          return 'siplast-calculator-results.pdf';
        };

        const link = document.createElement('a');
        link.target = '_blank';
        link.href = blobUrl;
        link.download = filename();
        link.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
          link.remove();
        }, 250);
      });

      if (elements.length === 1) {
        resolve();
      }
    } catch (e) {
      reject();
    }
  });
};

//clean and download pdf
export const cleanAndDownloadPdf = (
  printContainerRef,
  downloadDelayTime,
  fileName,
  downloadEndpoint
) => {
  const delay = Number(downloadDelayTime) || 0;
  const howToUse = document.querySelector(
    '.material-estimating-calculator__heading-container'
  );
  const form = printContainerRef.current.querySelector(
    '.material-estimating-calculator__form'
  );
  const resinSelect =
    printContainerRef.current.querySelector('.form-select-top');
  const formClone = form.cloneNode(true);
  const selectLabels = formClone.querySelectorAll('.form-select-top__label');
  const select = formClone.querySelectorAll('.form-select');
  const inputLabels = formClone.querySelectorAll('.form-input__label');
  const inputs = formClone.querySelectorAll('.form-input__field');
  const calculateButton = formClone.querySelector(
    '.material-estimating-calculator__form-input--calculate'
  );
  const checkboxes = formClone.querySelectorAll('.form-checkbox__input');
  calculateButton.remove();

  selectLabels.forEach(selectLabel => {
    selectLabel.style.position = 'static';
  });

  select.forEach(select => {
    select.classList.add('form-select--print');

    if (select.classList.contains('form-select-top')) {
      select.value = resinSelect.value.toLowerCase();
    }
  });

  inputLabels.forEach(inputLabel => {
    inputLabel.style.position = 'static';
  });

  inputs.forEach(input => {
    input.classList.add('form-input__field--print');
  });

  checkboxes.forEach(checkbox => {
    checkbox.classList.add('form-checkbox__input--print');
  });

  const resultsTables = printContainerRef.current.querySelectorAll(
    '.material-estimating-calculator__results'
  );

  const resultsTablesClone = Array.from(resultsTables).map(result => {
    const clone = result.cloneNode(true);
    const grid = clone.querySelector(
      '.material-estimating-calculator__results-grid'
    );
    const table = clone.querySelector(
      '.material-estimating-calculator__results-table'
    );

    if (table) {
      table.style.display = 'table';
    }

    if (grid) {
      grid.remove();
    }

    return clone;
  });

  const exampleTable = document.querySelector(
    '.material-estimating-calculator__waste-reference-chart-container'
  );

  const total = printContainerRef.current.querySelector(
    '.material-estimating-calculator__total'
  );

  const options = {
    margin: 15,
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    image: { type: 'jpeg', quality: 0.95 },
    filename: fileName,
    html2canvas: {
      dpi: 92,
      letterRendering: true,
      useCORS: true,
      scale: 2,
      allowTaint: true,
      imageTimeout: 15000,
      preferCanvas: true
    },
    jsPDF: {
      unit: 'mm',
      format: 'a3',
      orientation: 'landscape',
      compress: true
    }
  };

  const buttons = resultsTablesClone[1].querySelectorAll('button');
  buttons.forEach(button => {
    button.remove();
  });

  const elements = [howToUse, formClone, ...resultsTablesClone];

  if (total) {
    elements.push(total);
  }

  if (exampleTable) {
    elements.push(exampleTable);
  }

  const _downloadPDF = async (elements, options, downloadEndpoint) => {
    await downloadPDF(elements, options, downloadEndpoint);
  };

  setTimeout(() => {
    _downloadPDF(elements, options, downloadEndpoint);
  }, delay);
};

//calculate tooltip position on tooltip show
export const handleTooltipShow = e => {
  const tooltipButton = e.target;

  if (tooltipButton.tagName === 'BUTTON') {
    const tooltipParent = tooltipButton.parentElement;
    const tooltipBox = e.target.querySelector(
      '.material-estimating-calculator__tooltip-box'
    );

    if (
      tooltipButton.getBoundingClientRect().left -
        tooltipParent.getBoundingClientRect().left <
      66
    ) {
      tooltipBox.classList.add(
        'material-estimating-calculator__tooltip-box--alt'
      );
    } else {
      tooltipBox.classList.remove(
        'material-estimating-calculator__tooltip-box--alt'
      );
    }
  }
};
